"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$route.name === "home" ? _c("div", {
    staticClass: "side-nav"
  }, [_c("nav", {
    staticClass: "side navbar dark-pill-nav"
  }, [_c("el-tooltip", {
    attrs: {
      placement: "left",
      effect: "light",
      transition: "initial",
      offset: 15,
      "popper-class": "slide-nav-tool"
    }
  }, [_c("div", {
    staticClass: "tooltip-box",
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("div", {
    staticClass: "kefu_con_one"
  }, [_c("a", {
    attrs: {
      href: "javascript:void(0);"
    },
    on: {
      click: _vm.jumpOnline
    }
  }, [_vm._v("在线咨询")])])]), _c("div", {
    staticClass: "nav-item chat-item",
    attrs: {
      id: "side_kefus"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImageOnline(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImageOnline(false);
      },
      click: _vm.jumpOnline
    }
  }, [_c("div", {
    staticClass: "chat-circle"
  }, [_c("i", {
    staticClass: "el-icon-chat-dot-square"
  })])])]), _c("el-tooltip", {
    attrs: {
      placement: "left",
      effect: "light",
      transition: "initial",
      offset: 15,
      "popper-class": "slide-nav-tool"
    }
  }, [_c("div", {
    staticClass: "tooltip-box",
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("div", {
    staticClass: "kefu_con"
  }, [_c("img", {
    attrs: {
      src: require("../../src/assets/static/img/sidenav/06.png"),
      alt: ""
    }
  }), _c("a", {
    attrs: {
      href: "javascript:void(0);"
    }
  }, [_vm._v("400-886-3156")])])]), _c("div", {
    staticClass: "nav-item phone-item",
    attrs: {
      id: "side_kefu"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImage(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImage(false);
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-phone-outline"
  })])]), _c("div", {
    staticClass: "nav-divider"
  }), _c("el-backtop", {
    attrs: {
      target: _vm.bindId,
      "visibility-height": 10
    }
  }, [_c("div", {
    staticClass: "nav-item top-item",
    attrs: {
      id: "side_zhiding"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImageback(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImageback(false);
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-top"
  })])])], 1)]) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;